export default class Ws {
    ws!: WebSocket;
    constructor(url) {
        this.ws = new WebSocket(url);
    }

    initWs() {
        this.ws.onopen = () => {};
        this.ws.onmessage = (event) => {};
        this.ws.onclose = (event) => {};
        this.ws.onerror = () => {};
    }

    close() {
        this.ws.close();
    }

    send(data) {
        if (this.ws.readyState === this.ws.OPEN) {
            this.ws.send(data);
        }
    }
}
